import { useEffect } from 'react';
import { useSubstate } from 'use-substate';

import { client, useErrorNotifications } from 'core/http';
import { SetProducts } from 'core/Store/products/actions';
import { selectProducts } from 'core/Store/products/selectors';
import { Product } from 'core/types/product';

export default function useProducts() {
  const showErrorNotification = useErrorNotifications();
  const [products, dispatch] = useSubstate(selectProducts);

  useEffect(() => {
    if (products.length) {
      return;
    }

    client()
      .get<Product[]>('products')
      .then(response => dispatch(new SetProducts(response.data)))
      .catch(showErrorNotification);
  }, [dispatch, products, showErrorNotification]);

  return products;
}
